import React from 'react';
import { Cross1Icon } from '@radix-ui/react-icons';

import styles from './alert.module.scss';

interface AlertProps {
  type?: string;
  text: string;
  small?: boolean;
  onDelete?: () => void;
}

export const Alert: React.FC<AlertProps> = ({
  type = 'default',
  text,
  small = false,
  onDelete,
}) => (
  <div className={styles['alert-item']} data-type={type} data-small={small} data-close={!!onDelete}>
    <div>{text}</div>

    {!!onDelete && (
      <div className={styles.close} onClick={onDelete}>
        <Cross1Icon />
      </div>
    )}
  </div>
);
